angular.module('impactx.rfx').controller('RFXListComparisonOffersCtrl', [
    '$scope',
    '$redirect',
    'selectedListItems',
    '$routeParams',
    RFXListComparisonOffersCtrl]);

function RFXListComparisonOffersCtrl($scope, $redirect, selectedListItems, $routeParams) {
    var self = this;

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: canViewOffer,
            process: 'RFXView'
        },
        {
            label: "edit",
            linkFunction: getEditOfferLink,
            type: 'link',
            condition: canEditOffer,
            process: 'RFXSupplierEditForBuyer'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/rfx/templates/rfx-list-offers.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/list/comparisonoffers',
        id: "rfxlistcomparisonoffers",
        buttonDefinition: buttonDefinition,
        valuesInteger: [{name: "RFQH_Id", value: $routeParams.rfqhId}],
    };

    self.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "rfx/offer/" + selectedListItems.getFirstSelectedId();
    }

    function getEditOfferLink() {
        return "rfxsuppliereditbuyer/" + $routeParams.rfqhId + "/" + selectedListItems.getFirstSelectedId();
    }

    function canViewOffer() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canViewOffer.value;
    }

    function canEditOffer() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canEditOffer.value;
    }
}